import { config } from 'client/hooks/config';
import { Api } from 'common/utils/api';
import { useQuery } from 'react-query';

interface Response {
    procedureid: number;
    expiration_date: string;
}

export function useGetExpiringShares() {
    const { key, path } = config.videoexport.expiringShares();
    const { data, isLoading } = useQuery(key, () => Api.get<Response[]>({ path }), {});

    return {
        data: data,
        isLoading: isLoading,
    };
}
